import React from 'react';
import '../App.css';

const PrivacyPolicy: React.FC = () => {
    return (
        <div style={{ padding: '4rem 2rem', maxWidth: '800px', margin: '0 auto', color: '#333' }}>
            <h1 style={{ marginBottom: '1rem', fontSize: '2.5rem', color: '#000' }}>Privacy Policy</h1>
            <p style={{ marginBottom: '2rem', color: '#666' }}>Last updated: {new Date().toLocaleDateString()}</p>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>1. Introduction</h2>
                <p>
                    At Chibs Olympia ("we," "our," or "us"), we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or purchase our coaching services.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>2. Information We Collect</h2>
                <p style={{ marginBottom: '0.5rem' }}>We may collect information about you in a variety of ways. The information we may collect includes:</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem' }}>
                    <li><strong>Personal Data:</strong> Personally identifiable information, such as your name, shipping address, email address, and telephone number, that you voluntarily give to us when you register with the site or purchase a program.</li>
                    <li><strong>Health and Fitness Data:</strong> Information related to your physical characteristics, health goals, dietary habits, and fitness history that you provide to enable us to create personalized plans.</li>
                    <li><strong>Financial Data:</strong> Financial information, such as data related to your payment method (e.g., valid credit card number, card brand, expiration date) that we may collect when you purchase, order, return, exchange, or request information about our services.</li>
                </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>3. How We Use Your Information</h2>
                <p>We use the information we collect to:</p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem' }}>
                    <li>Create and manage your account.</li>
                    <li>Process your transactions and send you related information, including purchase confirmations and invoices.</li>
                    <li>Design personalized fitness and nutrition programs tailored to your goals.</li>
                    <li>Communicate with you about updates, new products, and services.</li>
                    <li>Monitor and analyze usage and trends to improve your experience with the website.</li>
                </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>4. Disclosure of Your Information</h2>
                <p>
                    We may share information we have collected about you in certain situations. Your information may be disclosed as follows:
                </p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem' }}>
                    <li><strong>By Law or to Protect Rights:</strong> If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others.</li>
                    <li><strong>Third-Party Service Providers:</strong> We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.</li>
                </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>5. Security of Your Information</h2>
                <p>
                    We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>6. Contact Us</h2>
                <p>
                    If you have questions or comments about this Privacy Policy, please contact us at: <br />
                    <a href="mailto:olympiaacademy@chibsolympia.com" style={{ color: '#0056b3', textDecoration: 'none', fontWeight: 'bold' }}>olympiaacademy@chibsolympia.com</a>
                </p>
            </section>
        </div>
    );
};

export default PrivacyPolicy;
